import { useState } from 'react';
import useMediaQuery from './useMediaQuery';
import memoize from 'fast-memoize';

// A custom hook for the below functionality:
// On desktop => Show icon only on hover
// On mobile => show
// Have a look at PopoverBaseHover component for more understanding.
const usePopoverBaseHover = (initialState = false) => {
  const { whenBelowMd } = useMediaQuery();
  const [showIcon, toggleIcon] = useState(whenBelowMd || initialState);

  const set = memoize(val => () => {
    if (whenBelowMd) {
      return;
    }
    toggleIcon(val);
  });

  return {
    showIcon,
    set,
  };
};

export default usePopoverBaseHover;
